
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import toast from "react-hot-toast";
// import { Chart as ChartJS, ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend } from "chart.js";
// import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
// import { EMPLOYER_URL } from "../../../resources/resource";
// import { useFetchData } from "../../../hooks/useFtechData";

// // Register Chart.js components
// ChartJS.register(ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend);

// const Dashboardhome = () => {
//   const currentUser = useSelector((state) => state.user.currentUser);
//   const navigate = useNavigate();
//   const { data, refetch } = useFetchData(`${EMPLOYER_URL}/getJobEmployer/${currentUser?._id}`);

//   // State for employee details and stats
//   const [employeeDetails, setEmployeeDetails] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState({
//     onlineJobs: 0,
//     totalApplications: 0,
//     totalViews: 0,
//     draft: 0,
//     awaitingApproval: 0,
//     rejected: 0,
//     offline: 0,
//   });
//   const [jobStatusCounts, setJobStatusCounts] = useState({});
//   const [jobsByStatus, setJobsByStatus] = useState({});
//   const [selectedStatus, setSelectedStatus] = useState(null);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [applicationStats, setApplicationStats] = useState({
//     Applied: 0,
//     Shortlisted: 0,
//     Interviewed: 0,
//     Offer: 0,
//     Rejected: 0,
//     Accepted: 0,
//     Scheduled: 0,
//   });
//   const [recentJobs, setRecentJobs] = useState([]);
//   const [jobCategoriesData, setJobCategoriesData] = useState({
//     labels: [],
//     datasets: [
//       {
//         label: "Job Postings",
//         data: [],
//         backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444"],
//         borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C"],
//         borderWidth: 1,
//       },
//     ],
//   });
//   const [applicationTrendsData, setApplicationTrendsData] = useState({
//     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//     datasets: [
//       {
//         label: "Applications",
//         data: [0, 0, 0, 0, 0, 0],
//         fill: false,
//         borderColor: "#7E22CE",
//         tension: 0.4,
//       },
//     ],
//   });
//   const [jobPostingsOverTimeData, setJobPostingsOverTimeData] = useState({
//     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//     datasets: [
//       {
//         label: "Job Postings",
//         data: [0, 0, 0, 0, 0, 0],
//         fill: false,
//         borderColor: "#4CAF50",
//         tension: 0.4,
//       },
//     ],
//   });
//   const [userEngagementData, setUserEngagementData] = useState({
//     labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
//     datasets: [
//       {
//         label: "Job Views",
//         data: [0, 0, 0, 0, 0, 0],
//         fill: false,
//         borderColor: "#3B82F6",
//         tension: 0.4,
//       },
//     ],
//   });
//   const [userRegistrationsData, setUserRegistrationsData] = useState({
//     labels: ["Job Seekers", "Employers"],
//     datasets: [
//       {
//         label: "Registrations",
//         data: [0, 0],
//         backgroundColor: ["#4CAF50", "#3B82F6"],
//         borderColor: ["#388E3C", "#2563EB"],
//         borderWidth: 1,
//       },
//     ],
//   });
//   const [applicationStatusData, setApplicationStatusData] = useState({
//     labels: ["Applied", "Shortlisted", "Interviewed", "Offer", "Rejected", "Accepted", "Scheduled"],
//     datasets: [
//       {
//         label: "Status",
//         data: [0, 0, 0, 0, 0, 0, 0],
//         backgroundColor: ["#F59E0B", "#4CAF50", "#3B82F6", "#10B981", "#EF4444", "#8B5CF6", "#EC4899"],
//         borderColor: ["#D97706", "#388E3C", "#2563EB", "#059669", "#B91C1C", "#6D28D9", "#DB2777"],
//         borderWidth: 1,
//       },
//     ],
//   });
//   const [waterfallData, setWaterfallData] = useState({
//     labels: ["Received", "Shortlisted", "Interviewed", "Offered", "Rejected", "Accepted", "Scheduled"],
//     datasets: [
//       {
//         label: "Applications",
//         data: [0, 0, 0, 0, 0, 0, 0],
//         backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"],
//         borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C", "#6D28D9", "#DB2777"],
//         borderWidth: 1,
//       },
//     ],
//   });

//   const calculateDaysLeft = (expiryDate) => {
//     if (!expiryDate) return "N/A";
//     const today = new Date();
//     const expiry = new Date(expiryDate);
//     const diffTime = expiry - today;
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? "s" : ""} left` : "Expired";
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         if (!currentUser || !currentUser._id) {
//           console.log("No employer ID found");
//           toast.error("No employer ID found. Please sign in again.");
//           navigate("/signin");
//           return;
//         }

//         const employerId = currentUser._id;
//         const token = localStorage.getItem("token");
//         if (!token) {
//           console.log("No authentication token found");
//           toast.error("No authentication token found. Please sign in again.");
//           navigate("/signin");
//           return;
//         }

//         // Fetch employer stats
//         const employerResponse = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/employer/${employerId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         console.log("Employer Response:", JSON.stringify(employerResponse.data, null, 2));
//         const employerData = employerResponse.data.data || employerResponse.data || {};
//         const newStats = {
//           onlineJobs: Number(employerData.onlineJobs) || 0,
//           totalApplications: Number(employerData.totalApplications) || 0,
//           totalViews: Number(employerData.totalViews) || 0,
//           draft: Number(employerData.draft) || 0,
//           awaitingApproval: Number(employerData.awaitingApproval) || 0,
//           rejected: Number(employerData.rejected) || 0,
//           offline: Number(employerData.offline) || 0,
//         };
//         console.log("Parsed Stats:", newStats);
//         setStats(newStats);

//         // Fetch jobs
//         const jobsResponse = await axios.get(`${process.env.REACT_APP_API_URL}job/employers/${employerId}/jobs`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         console.log("Jobs Response:", JSON.stringify(jobsResponse.data, null, 2));
//         const jobs = Array.isArray(jobsResponse.data.data) ? jobsResponse.data.data : Array.isArray(jobsResponse.data) ? jobsResponse.data : [];
//         if (!jobs.length) {
//           console.warn("No jobs data received");
//           toast.warn("No job postings found");
//         }
//         const sortedJobs = jobs
//           .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
//           .slice(0, 3);
//         const calculatedTotalViews = jobs.reduce((sum, job) => sum + (Array.isArray(job.uniqueViewers) ? job.uniqueViewers.length : 0), 0);
//         setRecentJobs(sortedJobs);
//         setStats((prev) => ({ ...prev, totalViews: prev.totalViews || calculatedTotalViews }));

//         // Job Status Counts
//         const statusCounts = {
//           Draft: newStats.draft,
//           "Awaiting Approval": newStats.awaitingApproval,
//           Online: newStats.onlineJobs,
//           Offline: newStats.offline,
//           Rejected: newStats.rejected,
//         };
//         console.log("Job Status Counts:", statusCounts);
//         setJobStatusCounts(statusCounts);
//         setJobsByStatus({
//           Draft: jobs.filter((job) => job.status === "Draft"),
//           "Awaiting Approval": jobs.filter((job) => job.status === "Awaiting Approval"),
//           Online: jobs.filter((job) => job.status === "Online"),
//           Offline: jobs.filter((job) => job.status === "Offline"),
//           Rejected: jobs.filter((job) => job.status === "Rejected"),
//         });

//         // Job Postings by Category (Bar Chart)
//         const industries = [...new Set(jobs.map((job) => job.industry || "Unknown"))].slice(0, 5);
//         const industryCounts = industries.map((industry) =>
//           jobs.filter((job) => job.industry === industry).length
//         );
//         console.log("Industries:", industries, "Counts:", industryCounts);
//         setJobCategoriesData({
//           labels: industries.length ? industries : ["No Data"],
//           datasets: [
//             {
//               label: "Job Postings",
//               data: industries.length ? industryCounts : [0],
//               backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444"],
//               borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C"],
//               borderWidth: 1,
//             },
//           ],
//         });

//         // Job Postings Over Time (Line Chart)
//         const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
//         const jobPostingsByMonth = months.map((month, index) => {
//           const monthStart = new Date(new Date().getFullYear(), index, 1);
//           const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
//           return jobs.filter((job) => {
//             const createdAt = job.createdAt ? new Date(job.createdAt) : null;
//             return createdAt && createdAt >= monthStart && createdAt <= monthEnd;
//           }).length;
//         });
//         console.log("Job Postings by Month:", jobPostingsByMonth);
//         setJobPostingsOverTimeData({
//           labels: months,
//           datasets: [
//             {
//               label: "Job Postings",
//               data: jobPostingsByMonth,
//               fill: false,
//               borderColor: "#4CAF50",
//               tension: 0.4,
//             },
//           ],
//         });

//         // Application Trends (Line Chart)
//         let allApplications = [];
//         for (const job of jobs) {
//           try {
//             const appResponse = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${job._id}`, {
//               headers: { Authorization: `Bearer ${token}` },
//             });
//             console.log(`Applications for Job ${job._id}:`, JSON.stringify(appResponse.data, null, 2));
//             const applications = Array.isArray(appResponse.data.data) ? appResponse.data.data : Array.isArray(appResponse.data) ? appResponse.data : [];
//             allApplications = [...allApplications, ...applications];
//           } catch (error) {
//             console.error(`Error fetching applications for job ${job._id}:`, error);
//           }
//         }
//         console.log("Total Applications:", allApplications.length);
//         const applicationsByMonth = months.map((month, index) => {
//           const monthStart = new Date(new Date().getFullYear(), index, 1);
//           const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
//           return allApplications.filter((app) => {
//             const createdAt = app.createdAt ? new Date(app.createdAt) : null;
//             return createdAt && createdAt >= monthStart && createdAt <= monthEnd;
//           }).length;
//         });
//         console.log("Applications by Month:", applicationsByMonth);
//         setApplicationTrendsData({
//           labels: months,
//           datasets: [
//             {
//               label: "Applications",
//               data: applicationsByMonth,
//               fill: false,
//               borderColor: "#7E22CE",
//               tension: 0.4,
//             },
//           ],
//         });

//         // Application Status (Doughnut Chart)
//         const statsApp = {
//           Applied: 0,
//           Shortlisted: 0,
//           Interviewed: 0,
//           Offer: 0,
//           Rejected: 0,
//           Accepted: 0,
//           Scheduled: 0,
//         };
//         allApplications.forEach((app) => {
//           if (app.status && statsApp.hasOwnProperty(app.status)) {
//             statsApp[app.status]++;
//           }
//         });
//         console.log("Application Status Stats:", statsApp);
//         setApplicationStatusData({
//           labels: ["Applied", "Shortlisted", "Interviewed", "Offer", "Rejected", "Accepted", "Scheduled"],
//           datasets: [
//             {
//               label: "Status",
//               data: [
//                 statsApp.Applied,
//                 statsApp.Shortlisted,
//                 statsApp.Interviewed,
//                 statsApp.Offer,
//                 statsApp.Rejected,
//                 statsApp.Accepted,
//                 statsApp.Scheduled,
//               ],
//               backgroundColor: ["#F59E0B", "#4CAF50", "#3B82F6", "#10B981", "#EF4444", "#8B5CF6", "#EC4899"],
//               borderColor: ["#D97706", "#388E3C", "#2563EB", "#059669", "#B91C1C", "#6D28D9", "#DB2777"],
//               borderWidth: 1,
//             },
//           ],
//         });

//         // Application Flow (Waterfall-like Bar Chart)
//         const totalReceived = allApplications.length;
//         console.log("Waterfall Data:", {
//           totalReceived,
//           Shortlisted: statsApp.Shortlisted,
//           Interviewed: statsApp.Interviewed,
//           Offer: statsApp.Offer,
//           Rejected: statsApp.Rejected,
//           Accepted: statsApp.Accepted,
//           Scheduled: statsApp.Scheduled,
//         });
//         setWaterfallData({
//           labels: ["Received", "Shortlisted", "Interviewed", "Offered", "Rejected", "Accepted", "Scheduled"],
//           datasets: [
//             {
//               label: "Applications",
//               data: [
//                 totalReceived,
//                 -(statsApp.Shortlisted || 0),
//                 -(statsApp.Interviewed || 0),
//                 -(statsApp.Offer || 0),
//                 -(statsApp.Rejected || 0),
//                 -(statsApp.Accepted || 0),
//                 -(statsApp.Scheduled || 0),
//               ],
//               backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"],
//               borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C", "#6D28D9", "#DB2777"],
//               borderWidth: 1,
//             },
//           ],
//         });

//         // User Engagement (Line Chart)
//         const viewsByMonth = months.map((month, index) => {
//           const monthStart = new Date(new Date().getFullYear(), index, 1);
//           const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
//           return jobs.reduce((sum, job) => {
//             const createdAt = job.createdAt ? new Date(job.createdAt) : null;
//             if (createdAt && createdAt >= monthStart && createdAt <= monthEnd) {
//               return sum + (Array.isArray(job.uniqueViewers) ? job.uniqueViewers.length : 0);
//             }
//             return sum;
//           }, 0);
//         });
//         console.log("Job Views by Month:", viewsByMonth);
//         setUserEngagementData({
//           labels: months,
//           datasets: [
//             {
//               label: "Job Views",
//               data: viewsByMonth,
//               fill: false,
//               borderColor: "#3B82F6",
//               tension: 0.4,
//             },
//           ],
//         });

//         // User Registrations (Pie Chart)
//         try {
//           const jobSeekerResponse = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           console.log("Job Seeker Response:", JSON.stringify(jobSeekerResponse.data, null, 2));
//           const jobSeekerCount = Array.isArray(jobSeekerResponse.data.data)
//             ? jobSeekerResponse.data.data.length
//             : Array.isArray(jobSeekerResponse.data)
//               ? jobSeekerResponse.data.length
//               : 0;
//           setUserRegistrationsData({
//             labels: ["Job Seekers", "Employers"],
//             datasets: [
//               {
//                 label: "Registrations",
//                 data: [jobSeekerCount, newStats.onlineJobs || 0],
//                 backgroundColor: ["#4CAF50", "#3B82F6"],
//                 borderColor: ["#388E3C", "#2563EB"],
//                 borderWidth: 1,
//               },
//             ],
//           });
//         } catch (error) {
//           console.error("Error fetching job seekers:", error);
//           toast.warn("Using placeholder data for User Registrations");
//           setUserRegistrationsData({
//             labels: ["Job Seekers", "Employers"],
//             datasets: [
//               {
//                 label: "Registrations",
//                 data: [800, 200],
//                 backgroundColor: ["#4CAF50", "#3B82F6"],
//                 borderColor: ["#388E3C", "#2563EB"],
//                 borderWidth: 1,
//               },
//             ],
//           });
//         }

//       } catch (error) {
//         console.error("Error fetching dashboard data:", error.response || error);
//         toast.error(error.response?.data?.message || "Failed to load dashboard data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     const fetchEmployeeDetails = async () => {
//       if (data?.employers && Array.isArray(data.employers)) {
//         try {
//           const token = localStorage.getItem("token");
//           const details = await Promise.all(
//             data.employers.map(async (id) => {
//               const response = await fetch(`${EMPLOYER_URL}/getEmployeeDetails/${id}`, {
//                 headers: { Authorization: `Bearer ${token}` },
//               });
//               const empData = await response.json();
//               return { id, name: empData.name || `Employee ${id}` };
//             })
//           );
//           console.log("Employee Details:", details);
//           setEmployeeDetails(details);
//         } catch (error) {
//           console.error("Error fetching employee details:", error);
//           toast.error("Failed to load employee details");
//         }
//       } else {
//         console.log("No employers data available for employee details:", data?.employers);
//       }
//     };

//     if (currentUser?._id) {
//       fetchData();
//       fetchEmployeeDetails();
//     }
//   }, [currentUser, data, navigate]);

//   const fetchApplicationStats = async (jobId) => {
//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${jobId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       console.log(`Application Stats for Job ${jobId}:`, JSON.stringify(response.data, null, 2));
//       const applications = Array.isArray(response.data.data) ? response.data.data : Array.isArray(response.data) ? response.data : [];
//       const stats = {
//         Applied: 0,
//         Shortlisted: 0,
//         Interviewed: 0,
//         Offer: 0,
//         Rejected: 0,
//         Accepted: 0,
//         Scheduled: 0,
//       };
//       applications.forEach((app) => {
//         if (app.status && stats.hasOwnProperty(app.status)) {
//           stats[app.status]++;
//         }
//       });
//       console.log("Application Stats:", stats);
//       setApplicationStats(stats);
//     } catch (error) {
//       console.error(`Error fetching application stats for job ${jobId}:`, error);
//       toast.error("Failed to load application stats");
//     }
//   };

//   return (
//     <div>
//       {loading ? (
//         <div className="flex justify-center items-center h-screen">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-e-ride-purple"></div>
//         </div>
//       ) : (
//         <div className="p-6 md:p-8 lg:p-10">
//           <h2 className="text-3xl font-bold text-gray-900 mb-8">Dashboard Overview</h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">Total Job Postings</h3>
//               <p className="text-3xl font-bold text-e-ride-purple">
//                 {stats.onlineJobs + stats.draft + stats.awaitingApproval + stats.offline + stats.rejected}
//               </p>
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">Total Applications</h3>
//               <p className="text-3xl font-bold text-customGreen">{stats.totalApplications}</p>
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">Active Users</h3>
//               <p className="text-3xl font-bold text-blue-600">{employeeDetails.length}</p>
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-2">New Registrations</h3>
//               <p className="text-3xl font-bold text-orange-600">
//                 {userRegistrationsData.datasets[0].data[0] + userRegistrationsData.datasets[0].data[1]}
//               </p>
//             </div>
//           </div>
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">Job Postings by Industry</h3>
//               {jobCategoriesData.labels[0] === "No Data" ? (
//                 <p className="text-gray-500 text-center">No job postings available</p>
//               ) : (
//                 <Bar
//                   data={jobCategoriesData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { display: false },
//                       title: { display: true, text: "Job Postings by Industry", font: { size: 16 } },
//                     },
//                     scales: {
//                       y: { beginAtZero: true },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Trends</h3>
//               {applicationTrendsData.datasets[0].data.every((val) => val === 0) ? (
//                 <p className="text-gray-500 text-center">No application data available</p>
//               ) : (
//                 <Line
//                   data={applicationTrendsData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { display: false },
//                       title: { display: true, text: "Applications per Month", font: { size: 16 } },
//                     },
//                     scales: {
//                       y: { beginAtZero: true },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">Job Postings Over Time</h3>
//               {jobPostingsOverTimeData.datasets[0].data.every((val) => val === 0) ? (
//                 <p className="text-gray-500 text-center">No job postings available</p>
//               ) : (
//                 <Line
//                   data={jobPostingsOverTimeData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { display: false },
//                       title: { display: true, text: "Job Postings per Month", font: { size: 16 } },
//                     },
//                     scales: {
//                       y: { beginAtZero: true },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">User Engagement</h3>
//               {userEngagementData.datasets[0].data.every((val) => val === 0) ? (
//                 <p className="text-gray-500 text-center">No engagement data available</p>
//               ) : (
//                 <Line
//                   data={userEngagementData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { display: false },
//                       title: { display: true, text: "Job Views per Month", font: { size: 16 } },
//                     },
//                     scales: {
//                       y: { beginAtZero: true },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">User Registrations</h3>
//               {userRegistrationsData.datasets[0].data.every((val) => val === 0) ? (
//                 <p className="text-gray-500 text-center">No registration data available</p>
//               ) : (
//                 <Pie
//                   data={userRegistrationsData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { position: "bottom" },
//                       title: { display: true, text: "User Registrations by Type", font: { size: 16 } },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Status</h3>
//               {applicationStatusData.datasets[0].data.every((val) => val === 0) ? (
//                 <p className="text-gray-500 text-center">No application status data available</p>
//               ) : (
//                 <Doughnut
//                   data={applicationStatusData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { position: "bottom" },
//                       title: { display: true, text: "Application Status Distribution", font: { size: 16 } },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//             <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
//               <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Flow (Waterfall)</h3>
//               {waterfallData.datasets[0].data[0] === 0 ? (
//                 <p className="text-gray-500 text-center">No application flow data available</p>
//               ) : (
//                 <Bar
//                   data={waterfallData}
//                   options={{
//                     responsive: true,
//                     plugins: {
//                       legend: { display: false },
//                       title: { display: true, text: "Application Flow", font: { size: 16 } },
//                     },
//                     scales: {
//                       y: { beginAtZero: true },
//                       x: { stacked: true },
//                     },
//                   }}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Dashboardhome;


































import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { Chart as ChartJS, ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend } from "chart.js";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import { EMPLOYER_URL } from "../../../resources/resource";
import { useFetchData } from "../../../hooks/useFtechData";

// Register Chart.js components
ChartJS.register(ArcElement, BarElement, LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend);

const Dashboardhome = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const navigate = useNavigate();
  const { data, refetch } = useFetchData(`${EMPLOYER_URL}/getJobEmployer/${currentUser?._id}`);

  // State for employee details and stats
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    onlineJobs: 0,
    totalApplications: 0,
    totalViews: 0,
    draft: 0,
    awaitingApproval: 0,
    rejected: 0,
    offline: 0,
  });
  const [jobStatusCounts, setJobStatusCounts] = useState({});
  const [jobsByStatus, setJobsByStatus] = useState({});
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [applicationStats, setApplicationStats] = useState({
    Applied: 0,
    Shortlisted: 0,
    Interviewed: 0,
    Offer: 0,
    Rejected: 0,
    Accepted: 0,
    Scheduled: 0,
  });
  const [recentJobs, setRecentJobs] = useState([]);
  const [jobCategoriesData, setJobCategoriesData] = useState({
    labels: [],
    datasets: [
      {
        label: "Job Postings",
        data: [],
        backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444"],
        borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C"],
        borderWidth: 1,
      },
    ],
  });
  const [applicationTrendsData, setApplicationTrendsData] = useState({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Applications",
        data: [0, 0, 0, 0, 0, 0],
        fill: false,
        borderColor: "#7E22CE",
        tension: 0.4,
      },
    ],
  });
  const [jobPostingsOverTimeData, setJobPostingsOverTimeData] = useState({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Job Postings",
        data: [0, 0, 0, 0, 0, 0],
        fill: false,
        borderColor: "#4CAF50",
        tension: 0.4,
      },
    ],
  });
  const [userEngagementData, setUserEngagementData] = useState({
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        label: "Job Views",
        data: [0, 0, 0, 0, 0, 0],
        fill: false,
        borderColor: "#3B82F6",
        tension: 0.4,
      },
    ],
  });
  const [userRegistrationsData, setUserRegistrationsData] = useState({
    labels: ["Job Seekers", "Employers"],
    datasets: [
      {
        label: "Registrations",
        data: [800, 200],
        backgroundColor: ["#4CAF50", "#3B82F6"],
        borderColor: ["#388E3C", "#2563EB"],
        borderWidth: 1,
      },
    ],
  });
  const [applicationStatusData, setApplicationStatusData] = useState({
    labels: ["Applied", "Shortlisted", "Interviewed", "Offer", "Rejected", "Accepted", "Scheduled"],
    datasets: [
      {
        label: "Status",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: ["#F59E0B", "#4CAF50", "#3B82F6", "#10B981", "#EF4444", "#8B5CF6", "#EC4899"],
        borderColor: ["#D97706", "#388E3C", "#2563EB", "#059669", "#B91C1C", "#6D28D9", "#DB2777"],
        borderWidth: 1,
      },
    ],
  });
  const [waterfallData, setWaterfallData] = useState({
    labels: ["Received", "Shortlisted", "Interviewed", "Offered", "Rejected", "Accepted", "Scheduled"],
    datasets: [
      {
        label: "Applications",
        data: [0, 0, 0, 0, 0, 0, 0],
        backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"],
        borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C", "#6D28D9", "#DB2777"],
        borderWidth: 1,
      },
    ],
  });

  const calculateDaysLeft = (expiryDate) => {
    if (!expiryDate) return "N/A";
    const today = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? "s" : ""} left` : "Expired";
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (!currentUser || !currentUser._id) {
          toast.error("No employer ID found. Please sign in again.");
          navigate("/signin");
          return;
        }

        const employerId = currentUser._id;
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("No authentication token found. Please sign in again.");
          navigate("/signin");
          return;
        }

        // Fetch employer stats
        const employerResponse = await axios.get(`${process.env.REACT_APP_API_URL}jobrecruiter/employer/${employerId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Employer Response:", employerResponse.data); // Debug log
        const employerData = employerResponse.data.data || employerResponse.data;
        const newStats = {
          onlineJobs: employerData.onlineJobs || 0,
          totalApplications: employerData.totalApplications || 0,
          totalViews: employerData.totalViews || 0,
          draft: employerData.draft || 0,
          awaitingApproval: employerData.awaitingApproval || 0,
          rejected: employerData.rejected || 0,
          offline: employerData.offline || 0,
        };
        setStats(newStats);

        // Fetch jobs
        const jobsResponse = await axios.get(`${process.env.REACT_APP_API_URL}job/employers/${employerId}/jobs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log("Jobs Response:", jobsResponse.data); // Debug log
        const jobs = Array.isArray(jobsResponse.data.data) ? jobsResponse.data.data : jobsResponse.data;
        if (!Array.isArray(jobs)) {
          console.error("Jobs data is not an array:", jobs);
          toast.error("Invalid jobs data received");
          return;
        }
        const sortedJobs = jobs
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .slice(0, 3);
        const calculatedTotalViews = jobs.reduce((sum, job) => sum + (job.uniqueViewers?.length || 0), 0);
        setRecentJobs(sortedJobs);
        setStats((prev) => ({ ...prev, totalViews: prev.totalViews || calculatedTotalViews }));

        // Job Status Counts
        const statusCounts = {
          Draft: newStats.draft || 0,
          "Awaiting Approval": newStats.awaitingApproval || 0,
          Online: newStats.onlineJobs || 0,
          Offline: newStats.offline || 0,
          Rejected: newStats.rejected || 0,
        };
        setJobStatusCounts(statusCounts);
        setJobsByStatus({
          Draft: jobs.filter((job) => job.status === "Draft"),
          "Awaiting Approval": jobs.filter((job) => job.status === "Awaiting Approval"),
          Online: jobs.filter((job) => job.status === "Online"),
          Offline: jobs.filter((job) => job.status === "Offline"),
          Rejected: jobs.filter((job) => job.status === "Rejected"),
        });

        // Job Postings by Category (Bar Chart)
        const industries = [...new Set(jobs.map((job) => job.industry || "Unknown"))].slice(0, 5);
        const industryCounts = industries.map((industry) =>
          jobs.filter((job) => job.industry === industry).length
        );
        console.log("Industries:", industries, "Counts:", industryCounts); // Debug log
        setJobCategoriesData({
          labels: industries.length ? industries : ["No Data"],
          datasets: [
            {
              label: "Job Postings",
              data: industries.length ? industryCounts : [0],
              backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444"],
              borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C"],
              borderWidth: 1,
            },
          ],
        });

        // Job Postings Over Time (Line Chart)
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"];
        const jobPostingsByMonth = months.map((month, index) => {
          const monthStart = new Date(new Date().getFullYear(), index, 1);
          const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
          return jobs.filter((job) => {
            const createdAt = new Date(job.createdAt);
            return createdAt >= monthStart && createdAt <= monthEnd;
          }).length;
        });
        console.log("Job Postings by Month:", jobPostingsByMonth); // Debug log
        setJobPostingsOverTimeData({
          labels: months,
          datasets: [
            {
              label: "Job Postings",
              data: jobPostingsByMonth,
              fill: false,
              borderColor: "#4CAF50",
              tension: 0.4,
            },
          ],
        });

        // Application Trends (Line Chart)
        let allApplications = [];
        for (const job of jobs) {
          try {
            const appResponse = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${job._id}`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            console.log(`Applications for Job ${job._id}:`, appResponse.data); // Debug log
            const applications = Array.isArray(appResponse.data.data) ? appResponse.data.data : appResponse.data;
            allApplications = [...allApplications, ...applications];
          } catch (error) {
            console.error(`Error fetching applications for job ${job._id}:`, error);
          }
        }
        const applicationsByMonth = months.map((month, index) => {
          const monthStart = new Date(new Date().getFullYear(), index, 1);
          const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
          return allApplications.filter((app) => {
            const createdAt = new Date(app.createdAt);
            return createdAt >= monthStart && createdAt <= monthEnd;
          }).length;
        });
        console.log("Applications by Month:", applicationsByMonth); // Debug log
        setApplicationTrendsData({
          labels: months,
          datasets: [
            {
              label: "Applications",
              data: applicationsByMonth,
              fill: false,
              borderColor: "#7E22CE",
              tension: 0.4,
            },
          ],
        });

        // Application Status (Doughnut Chart)
        const statsApp = {
          Applied: 0,
          Shortlisted: 0,
          Interviewed: 0,
          Offer: 0,
          Rejected: 0,
          Accepted: 0,
          Scheduled: 0,
        };
        allApplications.forEach((app) => {
          if (statsApp[app.status]) statsApp[app.status]++;
        });
        console.log("Application Status Stats:", statsApp); // Debug log
        setApplicationStatusData({
          labels: ["Applied", "Shortlisted", "Interviewed", "Offer", "Rejected", "Accepted", "Scheduled"],
          datasets: [
            {
              label: "Status",
              data: [
                statsApp.Applied,
                statsApp.Shortlisted,
                statsApp.Interviewed,
                statsApp.Offer,
                statsApp.Rejected,
                statsApp.Accepted,
                statsApp.Scheduled,
              ],
              backgroundColor: ["#F59E0B", "#4CAF50", "#3B82F6", "#10B981", "#EF4444", "#8B5CF6", "#EC4899"],
              borderColor: ["#D97706", "#388E3C", "#2563EB", "#059669", "#B91C1C", "#6D28D9", "#DB2777"],
              borderWidth: 1,
            },
          ],
        });

        // Application Flow (Waterfall-like Bar Chart)
        const totalReceived = allApplications.length;
        setWaterfallData({
          labels: ["Received", "Shortlisted", "Interviewed", "Offered", "Rejected", "Accepted", "Scheduled"],
          datasets: [
            {
              label: "Applications",
              data: [
                totalReceived,
                -(statsApp.Shortlisted || 0),
                -(statsApp.Interviewed || 0),
                -(statsApp.Offer || 0),
                -(statsApp.Rejected || 0),
                -(statsApp.Accepted || 0),
                -(statsApp.Scheduled || 0),
              ],
              backgroundColor: ["#7E22CE", "#4CAF50", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899"],
              borderColor: ["#6B21A8", "#388E3C", "#2563EB", "#D97706", "#B91C1C", "#6D28D9", "#DB2777"],
              borderWidth: 1,
            },
          ],
        });

        // User Engagement (Line Chart) - Using uniqueViewers
        const viewsByMonth = months.map((month, index) => {
          const monthStart = new Date(new Date().getFullYear(), index, 1);
          const monthEnd = new Date(new Date().getFullYear(), index + 1, 0);
          return jobs.reduce((sum, job) => {
            const createdAt = new Date(job.createdAt);
            if (createdAt >= monthStart && createdAt <= monthEnd) {
              return sum + (job.uniqueViewers?.length || 0);
            }
            return sum;
          }, 0);
        });
        console.log("Job Views by Month:", viewsByMonth); // Debug log
        setUserEngagementData({
          labels: months,
          datasets: [
            {
              label: "Job Views",
              data: viewsByMonth,
              fill: false,
              borderColor: "#3B82F6",
              tension: 0.4,
            },
          ],
        });

        // User Registrations (Pie Chart) - Placeholder
        setUserRegistrationsData({
          labels: ["Job Seekers", "Employers"],
          datasets: [
            {
              label: "Registrations",
              data: [800, 200],
              backgroundColor: ["#4CAF50", "#3B82F6"],
              borderColor: ["#388E3C", "#2563EB"],
              borderWidth: 1,
            },
          ],
        });

      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        toast.error(error.response?.data?.message || "Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };

    const fetchEmployeeDetails = async () => {
      if (data?.employers) {
        try {
          const details = await Promise.all(
            data.employers.map(async (id) => {
              const response = await fetch(`${EMPLOYER_URL}/getEmployeeDetails/${id}`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
              });
              const empData = await response.json();
              return { id, name: empData.name || `Employee ${id}` };
            })
          );
          console.log("Employee Details:", details); // Debug log
          setEmployeeDetails(details);
        } catch (error) {
          console.error("Error fetching employee details:", error);
          toast.error("Failed to load employee details");
        }
      } else {
        console.log("No employers data available for employee details"); // Debug log
      }
    };

    fetchData();
    fetchEmployeeDetails();
  }, [currentUser, data, navigate]);

  const fetchApplicationStats = async (jobId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}application/getApplicationByJobId/${jobId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log(`Application Stats for Job ${jobId}:`, response.data); // Debug log
      const applications = Array.isArray(response.data.data) ? response.data.data : response.data;
      const stats = {
        Applied: 0,
        Shortlisted: 0,
        Interviewed: 0,
        Offer: 0,
        Rejected: 0,
        Accepted: 0,
        Scheduled: 0,
      };
      applications.forEach((app) => {
        if (stats[app.status]) stats[app.status]++;
      });
      setApplicationStats(stats);
    } catch (error) {
      console.error(`Error fetching application stats for job ${jobId}:`, error);
      toast.error("Failed to load application stats");
    }
  };

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-e-ride-purple"></div>
        </div>
      ) : (
        <div className="p-6 md:p-8 lg:p-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Dashboard Overview</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Total Job Postings</h3>
              <p className="text-3xl font-bold text-e-ride-purple">
                {stats.onlineJobs + stats.draft + stats.awaitingApproval + stats.offline + stats.rejected}
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Total Applications</h3>
              <p className="text-3xl font-bold text-customGreen">{stats.totalApplications}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Active Users</h3>
              <p className="text-3xl font-bold text-blue-600">{employeeDetails.length}</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">New Registrations</h3>
              <p className="text-3xl font-bold text-orange-600">456</p>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Job Postings by Industry</h3>
              <Bar
                data={jobCategoriesData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: { display: true, text: "Job Postings by Industry", font: { size: 16 } },
                  },
                  scales: {
                    y: { beginAtZero: true },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Trends</h3>
              <Line
                data={applicationTrendsData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: { display: true, text: "Applications per Month", font: { size: 16 } },
                  },
                  scales: {
                    y: { beginAtZero: true },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Job Postings Over Time</h3>
              <Line
                data={jobPostingsOverTimeData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: { display: true, text: "Job Postings per Month", font: { size: 16 } },
                  },
                  scales: {
                    y: { beginAtZero: true },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">User Engagement</h3>
              <Line
                data={userEngagementData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: { display: true, text: "Job Views per Month", font: { size: 16 } },
                  },
                  scales: {
                    y: { beginAtZero: true },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">User Registrations</h3>
              <Pie
                data={userRegistrationsData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "bottom" },
                    title: { display: true, text: "User Registrations by Type", font: { size: 16 } },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Status</h3>
              <Doughnut
                data={applicationStatusData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { position: "bottom" },
                    title: { display: true, text: "Application Status Distribution", font: { size: 16 } },
                  },
                }}
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Application Flow (Waterfall)</h3>
              <Bar
                data={waterfallData}
                options={{
                  responsive: true,
                  plugins: {
                    legend: { display: false },
                    title: { display: true, text: "Application Flow", font: { size: 16 } },
                  },
                  scales: {
                    y: { beginAtZero: true },
                    x: { stacked: true },
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboardhome;